export class AppUris {
    public IdentityServerUri: string = "";
    public UCUri: string = "";
    public GETUri: string = "";
    public oldUCUri: string = "";
    public oldGETUri: string = "";
}
export class selectionChangeForDetection
{
    customerId: number = 0;
    jobsiteId: number = 0;
    equipmentId: number = 0;
    familyId: number = 0;
    makeId: number = 0;
    modelId: number = 0;
}
export class AppRoute {
    routeEventTime: Date = new Date(0);
    routeId: number = 0;
    routeLevel: number = 0;
    routePath: string = '';
    itemId: number = 0;
    hasParam: boolean = false;
    routeTitle: string = '';
}
export class PageComponent {
    Id: number = 0;
    Title: string = "";
    Show: boolean = true;
}


export class EnabledSearch{
    public SowTabs:boolean
}